import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=22aad88e&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserDropdown: require('/server/itg-custom/staging/front/components/UserDropdown.vue').default,UiBtn: require('/server/itg-custom/staging/front/components/UiBtn.vue').default})
